// Add your custom JS here.

var $=jQuery.noConflict();

jQuery(function() {
    "use strict";


///////////////////////////////////////
// Browser Detection
///////////////////////////////////////

  // browser detect
  var BrowserDetect = {
    init: function () {
        this.browser = this.searchString(this.dataBrowser) || "Other";
        this.version = this.searchVersion(navigator.userAgent) || this.searchVersion(navigator.appVersion) || "Unknown";
    },
    searchString: function (data) {
        for (var i = 0; i < data.length; i++) {
            var dataString = data[i].string;
            this.versionSearchString = data[i].subString;
  
            if (dataString.indexOf(data[i].subString) !== -1) {
                return data[i].identity;
            }
        }
    },
    searchVersion: function (dataString) {
        var index = dataString.indexOf(this.versionSearchString);
        if (index === -1) {
            return;
        }
  
        var rv = dataString.indexOf("rv:");
        if (this.versionSearchString === "Trident" && rv !== -1) {
            return parseFloat(dataString.substring(rv + 3));
        } else {
            return parseFloat(dataString.substring(index + this.versionSearchString.length + 1));
        }
    },
  
    dataBrowser: [
        {string: navigator.userAgent, subString: "Edge", identity: "MS Edge"},
        {string: navigator.userAgent, subString: "MSIE", identity: "Explorer"},
        {string: navigator.userAgent, subString: "Trident", identity: "Explorer"},
        {string: navigator.userAgent, subString: "Firefox", identity: "Firefox"},
        {string: navigator.userAgent, subString: "Opera", identity: "Opera"},  
        {string: navigator.userAgent, subString: "OPR", identity: "Opera"},  
  
        {string: navigator.userAgent, subString: "Chrome", identity: "Chrome"}, 
        {string: navigator.userAgent, subString: "Safari", identity: "Safari"}       
    ]
  };
  
  BrowserDetect.init();
  //alert("You are using - " + BrowserDetect.browser + " - version - " + BrowserDetect.version + ".");
  
  // Done with IE11 and below | Not below Edge 18
  if (BrowserDetect.browser === 'Explorer' && BrowserDetect.version <= 11 || BrowserDetect.browser === 'MS Edge' && BrowserDetect.version <= 18.19041 ){
  $('#outdated').show();
  $('body').addClass("fixbody");
  $('#bVersion').empty().append( BrowserDetect.browser + " | Version " + BrowserDetect.version + " | Detected.");
  } 

////////////////////////////////////////////////////
// Device and useragent checking (using Modernizr)
////////////////////////////////////////////////////
var deviceAgent = navigator.userAgent.toLowerCase();

var isTouchDevice = Modernizr.touch || 
(deviceAgent.match(/(iphone|ipod|ipad)/) ||
deviceAgent.match(/(android)/)  || 
deviceAgent.match(/(iemobile)/) || 
deviceAgent.match(/iphone/i) || 
deviceAgent.match(/ipad/i) || 
deviceAgent.match(/ipod/i) || 
deviceAgent.match(/blackberry/i) || 
deviceAgent.match(/bada/i));

if (isTouchDevice) {
    // Is touch device
    $('.opacity-cover').remove(); // Remove opacity cover
    $('.video-background').remove(); // Remove video
    $(".header-wrap.full-vh").addClass('fallback'); // Add our fallback image
}


////////////////////////////////////////////////////
// Prefers reduced motion (Accessibility)
////////////////////////////////////////////////////

var motionQuery = matchMedia('(prefers-reduced-motion)');

function reducedMotionCheck() {
  if ( motionQuery.matches ) {
    
    $('.opacity-cover').hide(); // Hide opacity cover
    $('.video-background').hide(); // Hide video
    $(".header-wrap.full-vh").addClass('fallback'); // Add our fallback image
    
  } else if (!isTouchDevice) {

    $('.opacity-cover').show(); // Show opacity cover
    $('.video-background').show(); // Show video
    $(".header-wrap.full-vh").removeClass('fallback'); // Remove our fallback image

  }
}
reducedMotionCheck(); 
motionQuery.addEventListener("change",reducedMotionCheck); 

///////////////////////////////////////////////////
  // Sticky Nav
///////////////////////////////////////////////////


$(function() {

    $.fn.sticky = function(options) {
      var defaults = {
        topSpacing: 0, // No spacing by default
        zIndex: '', // No default z-index
        stopper: '.sticky-stopper', // Default stopper class, also accepts number value
        stickyClass: false // Class applied to element when it's stuck
      };
      var settings = $.extend({}, defaults, options); // Accepts custom stopper id or class
  
      // Checks if custom z-index was defined
      function checkIndex() {
        if (typeof settings.zIndex == 'number') {
          return true;
        } else {
          return false;
        }
      }
  
      var hasIndex = checkIndex(); // True or false
  
      // Checks if a stopper exists in the DOM or number defined
      function checkStopper() {
        if (0 < $(settings.stopper).length || typeof settings.stopper === 'number') {
          return true;
        } else {
          return false;
        }
      }
      var hasStopper = checkStopper(); // True or false
  
      return this.each(function() {
  
        var $this = $(this);
        var thisHeight = $this.outerHeight();
        var thisWidth = $this.outerWidth();
        var topSpacing = settings.topSpacing;
        var zIndex = settings.zIndex;
        var pushPoint = $this.offset().top - topSpacing; // Point at which the sticky element starts pushing
        var placeholder = $('<div></div>').width(thisWidth).height(thisHeight).addClass('sticky-placeholder'); // Cache a clone sticky element
        var stopper = settings.stopper;
        var $window = $(window);
  
        function stickyScroll() {
  
          var windowTop  = $window.scrollTop(); // Check window's scroll position
          var stopPoint = stopper;
          var parentWidth = $this.parent().width();
  
          placeholder.width(parentWidth)
  
          if ( hasStopper && typeof stopper === 'string' ) {
            var stopperTop = $(stopper).offset().top;
            stopPoint  = (stopperTop - thisHeight) - topSpacing;
          }
  
          if (pushPoint < windowTop) {
            // Create a placeholder for sticky element to occupy vertical real estate
            if(settings.stickyClass)
              $this.addClass(settings.stickyClass);
  
            $this.after(placeholder).css({
              position: 'fixed',
              top: topSpacing,
              //width: parentWidth,
              width: '100vw',
              left: 0
            });
  
            if (hasIndex) {
              $this.css({
                zIndex: zIndex
              });
            }
  
            if (hasStopper) {
              if (stopPoint < windowTop) {
                var diff = (stopPoint - windowTop) + topSpacing;
                $this.css({
                  top: diff
                });
           
              }
            }
          } else {
            if(settings.stickyClass)
              $this.removeClass(settings.stickyClass);
  
            $this.css({
              position: 'relative',
              top: 0,
              left: null,
              width: 'auto',
              zIndex: 0,
            });
            
            placeholder.remove();
          }
        }
        
          function myFunction(x) {
            // If max-width: 991px & sticky-bar, destroy the sticky scroll 
            if ((x.matches) && ($('div, a').hasClass("sticky-bar"))) {  
               
                 $window.unbind('scroll', stickyScroll);
                 $window.unbind('load', stickyScroll);
                 $window.unbind('resize', stickyScroll);
                 $(".sticky-bar").css({"position": "relative", "top": "0", "width": "auto", "z-index": "0"});
                 $('.sticky-bar').removeClass("stuck");
                 placeholder.remove();
              
            } else {
         
              if($window.innerHeight() > thisHeight) {
                  $window.bind('scroll', stickyScroll);
                  $window.bind('load', stickyScroll);
                  $window.bind('resize', stickyScroll);
              }
            }
          }
         
        var x = window.matchMedia("(max-width: 991px)")
        myFunction(x) // Call listener function at run time
        x.addEventListener("change",myFunction) // Attach listener function on state changes
      
      });
    };
  });
  
  // Render the sticky options
  $(function(){
    $(".sticky-bar").sticky({
        topSpacing: 81,
        zIndex:4,
        stopper: ".sticky-stop",
        stickyClass: "stuck"
    });
  });

///////////////////////////////////////////////////////
  // Add selected class to the categories 
///////////////////////////////////////////////////////

  // $(function(){
 
	// //Add the class selected to the item that is clicked, and remove from the others
	// var $optionSets = $('#filters'),
	// $optionLinks = $optionSets.find('a');
 
  //   $optionLinks.click(function(){
  //   var $this = $(this);
  //   // don't proceed if already selected
  //   if ( $this.hasClass('selected') ) {
  //     return false;
  //   }
  //   var $optionSet = $this.parents('#filters');
  //   $optionSets.find('.selected').removeClass('selected');
  //   $this.addClass('selected');
  
  //   return false;// For isotope only
  //   });

  // });

///////////////////////////////////////////////////////
  // BS Carousel Captions
  // Move carousel caption to #newCaption
  // by default show the first slide description
///////////////////////////////////////////////////////
  
  $(function() {
    var html = $('#caption-0').html();
    $('#newCaption').html(html);
    $("#quoteCarousel").on('slide.bs.carousel', function(evt) {
      //step - current slide e.g 0, 1, 2
      var step = $(evt.relatedTarget).index(); 
      html = $('#caption-' + step).html();
        $('#newCaption').html(html);
    });
  });

/////////////////////////////////////////////////////////////
// WP Search Validation (no empty searches)
/////////////////////////////////////////////////////////////

$(function() {
  $("#searchsubmit").on('click', function() {
      var hasError = false;
      var searchVal = $("#s-1").val();

      if(searchVal == '') {
          $('#searchform input').addClass("error");
          hasError = true;
      }else{
          $('#searchform input').removeClass("error");
          hasError = false;
      }
      if(hasError == true) {return false;}
  });
});

/////////////////////////////////////////////////////////////
// Hide Mega Menu on scroll
/////////////////////////////////////////////////////////////


var curScrollposition = 0;
var toggleElem = "ul#mega-menu li.mega-menu-parent a.dropdown-toggle, ul#mega-menu li.nav-item.menu-item-has-children a.dropdown-toggle";
// $(toggleElem).on("click",function(){
//   curScrollposition =  $(document).scrollTop();
//   var stickyBar = $('.sticky-bar').outerHeight();
//   var mainNav = $('#main-nav').outerHeight();
//   // Move the mega menu below the sticky info-bar when it's stuck
//   if ($(".sticky-bar").hasClass('stuck') && Modernizr.mq('(min-width: 991px)')){
//     $(".mega-menu-wrapper").css({"top": stickyBar + mainNav -2});// Mega Menu
//   } else {
//     $(".mega-menu-wrapper").removeAttr("style", stickyBar + mainNav); 
//   }
// });

$(document).scroll(function() {    
    var scroll = $(document).scrollTop();
    if(scroll < curScrollposition )
      scroll = curScrollposition - scroll; // If scroll down
    else
      scroll = scroll - curScrollposition; // If scroll Up

    if (scroll >= 50) { // amount in px to trigger hiding
      $("ul.mega-menu-wrapper, ul.dropdown-menu").fadeOut(300);
      setTimeout(function() { 
        $(toggleElem).removeClass("show").attr("aria-expanded", "false"); 
        $("ul.mega-menu-wrapper, ul.dropdown-menu").removeClass("show").removeAttr("data-bs-popper", "none"); 
        $("ul.mega-menu-wrapper, ul.dropdown-menu").removeAttr("style", "display: none;"); 
      }, 150);
    }
});



// Force theb Mega Menu to always show for testing purposes only
// $(function(){
//     $("ul#mega-menu li.mega-menu-parent a.dropdown-toggle").addClass("show").attr("aria-expanded", "true"); 
//     $("ul.mega-menu-wrapper").addClass("show").attr("data-bs-popper", "none"); 
// });

/////////////////////////////////////////////////////////////
// Customize the Workable Embed Widget
/////////////////////////////////////////////////////////////

$(document).ready(function(){
  setTimeout(function() { 
    $('.whr-item').each(function() {
      // Get the href attribute from the a element inside the whr-title
      var href = $(this).find('.whr-title a').attr('href');

      // Create a button element with the copied href as the href attribute
      var button = $('<a class="btn bg-d-pink px-3" href="' + href + '" target="_blank">Apply Now</a>');
      // create the microtitle element
      var microTitle = $('<p class="post-type-heading">Careers</p>');

      // Insert the button after the ul.whr-info tag
      $(this).find('.whr-info').after(button);
      // Insert the micro title
      $(this).find('.whr-title').before(microTitle);
    });
  }, 300);
});


});// End jQuery